(function () {
    'use strict';

    function PersonInfoSpaceComponentController($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.necessaryFieldsCheck = necessaryFieldsCheck;
        $ctrl.selectedId = '';

        loadAll();
        loadPage();

        function loadAll() {


            if ($ctrl.personInfo == null || $ctrl.personInfo == undefined)
                $ctrl.personInfo = {};

            $ctrl.personInfo.lastName = ' ';

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function necessaryFieldsCheck() {

        }

        function loadPage(page) {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

        }

    }

    var PersonInfoSpaceComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/person-info-space/partial-form.person-info-space.html',
        controller: PersonInfoSpaceComponentController,
        bindings:
            {
                personInfo: '=',
                servantCode: '=',
                userAccountId: '=',
                isCustomer: '=',
                isServant: '=',
                blockEditPhoneNumber: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfPersonInfoSpace', PersonInfoSpaceComponent)

    PersonInfoSpaceComponentController.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

